import { render } from "./ExpressSettings.vue?vue&type=template&id=c942c0d2&scoped=true"
import script from "./ExpressSettings.vue?vue&type=script&lang=js"
export * from "./ExpressSettings.vue?vue&type=script&lang=js"

import "./ExpressSettings.vue?vue&type=style&index=0&id=c942c0d2&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c942c0d2"]])

export default __exports__